/*
 *
 * File JS per la pagina Tutela Minori
 *
 */


// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import accordion from "imComponents/old-accordion/accordion";
//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./tutela-minori.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
accordion();

//--------------------------------------------------------------------//

const gestisciClasseAltro = (select, input) => {
  input.classList.toggle('active', select.value === 'Altro');
};

const collegaEventoECaricaClasseIniziale = (selectQuery, inputQuery) => {
  const select = document.querySelector(selectQuery);
  const input = document.querySelector(inputQuery);

  if (select && input) {
    select.addEventListener('change', () => {
      gestisciClasseAltro(select, input);
    });

    gestisciClasseAltro(select, input); // Iniziale gestione della classe
  }
};

const tutelaMinori = () => {
  const coppieElementi = [
    ['.wpcf7-select[name="segnalazione"]', '.wpcf7-text[name="segnalazione-altro"]'],
    ['.wpcf7-select[name="luogo"]', '.wpcf7-text[name="luogo-altro"]'],
    ['.wpcf7-select[name="motivazione"]', '.wpcf7-text[name="motivazione-altro"]'],
    ['.wpcf7-select[name="responsabile"]', '.wpcf7-text[name="responsabile-altro"]'],
  ];

  coppieElementi.forEach(([selectQuery, inputQuery]) => {
    collegaEventoECaricaClasseIniziale(selectQuery, inputQuery);
  });
};

tutelaMinori();


